import React, { useEffect, useState } from "react";
import {
  createSub,
  deleteSub,
  getSub,
  updateSub,
} from "../../services/Admin/adminServices";
import Dropdown from "react-bootstrap/Dropdown";
import { Button, Modal, Form } from "react-bootstrap";
import toast from "react-hot-toast";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";

import { useNavigate, useParams } from "react-router-dom";
import Pagination from "../components/Pagination";
import Spinner from "../components/Common/Spinner";
import LocationSearchDropdown from "../components/LocationDropDown";
import { debounce } from "lodash";
import LocationAdd from "../components/LocationAdd";

const SubSubjects = () => {
  const { id } = useParams();
  const [service, setService] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const navigate = useNavigate();
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmData, setConfirmData] = useState(null);
  const openDeleteConfirm = (serviceItem) => {
    setConfirmData(serviceItem);
    setConfirmModal(true);
  };

  const getservices = async () => {
    try {
      setLoading(true);

      const response = await getSub(id, currentPage, 10, debouncedSearch);

      setService(response?.data?.data?.subCategories);
      setTotalItems(response?.data?.data?.total);
    } catch (error) {
      console.error("errors", error);
    } finally {
      setLoading(false);
    }
  };

  const handleView = (serviceItem) => {
    setSelectedService(serviceItem);
    setShowModal(true);
  };
  const handleClose = () => {
    setShowModal(false);
    setSelectedService(null);
  };

  const confirmDelete = async () => {
    try {
      await deleteSub(confirmData._id);

      setService((prev) => prev.filter((s) => s._id !== confirmData._id));
      setTotalItems((prev) => prev - 1);
      toast.success("Deleted successfully");
    } catch (error) {
      toast.error("Failed to delete sub category");
      console.error(error);
    } finally {
      setConfirmModal(false);
      setConfirmData(null);
    }
  };
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );
  useEffect(() => {
    const handler = debounce(() => {
      setDebouncedSearch(search);
    }, 500);

    handler();

    return () => {
      handler.cancel();
    };
  }, [search]);

  useEffect(() => {
    getservices();
  }, [currentPage, debouncedSearch]);

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // inside SearchCompoment.jsx

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Title is required"),
  });

  const initialFormValues = {
    name: "",
    categoryId: id,
  };

  return (
    <div>
      <div className="d-flex flex-wrap justify-content-between gap-2 align-items-center ">
        <h1 style={{ color: "#87C55F" }}>Sub Category</h1>
        <h5 style={{ color: "#87C55F" }}>
          {" "}
          {service[0]?.categoryId?.name
            ? `Category ref :- ${service[0]?.categoryId?.name}`
            : ""}
        </h5>
      </div>

      <div className="pb-2 d-flex flex-wrap justify-content-between gap-2 align-items-center mb-4">
        <div className="flex-grow-1">
          <input
            type="text"
            style={{ borderRadius: "0.5rem", borderColor: "#87C55F" }}
            className="form-control w-100"
            placeholder="Search....."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div>
          <button
            className="btn"
            style={{
              backgroundColor: "#87C55F",
              color: "white", // text color
              border: "none", // remove border
              padding: "8px 16px", // optional padding
              borderRadius: "4px",
              marginBottom: "4px", // optional rounded corners
            }}
            onClick={() => setShowModal(true)}
          >
            Add new
          </button>
        </div>
      </div>
      {/* Table */}
      {loading ? (
        <Spinner />
      ) : service.length === 0 ? (
        <div className="text-center py-5">
          <h5>No Sub category Found</h5>
          <p className="text-muted">Click Add New to create one</p>
        </div>
      ) : (
        <div className="card shadow-sm border-0">
          <div className="table-responsive">
            <table className="table align-middle mb-0">
              {/* Table Head */}
              <thead
                style={{
                  backgroundColor: "#f8f9fa",
                }}
              >
                <tr>
                  <th style={{ width: "80px" }}>#</th>
                  <th>Name</th>
                        <th>Total Q/s</th>
                  <th>Created At</th>
                  <th style={{ width: "150px" }}>Actions</th>
                </tr>
              </thead>

              {/* Table Body */}
              <tbody>
                {service.map((item, index) => (
                  <tr
                    key={item._id}
                    style={{
                      transition: "0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#f8fdf5")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "white")
                    }
                  >
                    {/* Serial Number */}
                    <td>{currentPage * itemsPerPage + index + 1}</td>

                    {/* Name */}
                    <td>
                      <div className="fw-semibold">
                        {item.name.charAt(0).toUpperCase()}
                        {item.name.slice(1)}
                      </div>
                    </td>
                      <td>
                      <div className="fw-semibold">
                        {item?.questionCount}
             
                      </div>
                    </td>
                    <td>
                      <div className="fw-semibold">
                        {new Date(item.createdAt).toLocaleString("en-IN", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                      </div>
                    </td>
                    {/* Actions */}
                    <td>
                      <Dropdown align="end">
                        <Dropdown.Toggle
                          variant="light"
                          className="border-0 shadow-sm"
                          style={{
                            borderRadius: "8px",
                            padding: "6px 10px",
                          }}
                        >
                          {svg1}
                        </Dropdown.Toggle>

                        {/* ADD THE PROPS BELOW */}
                        <Dropdown.Menu
                          align="end"
                          popperConfig={{ strategy: "fixed" }}
                          renderOnMount
                        >
                          <Dropdown.Item onClick={() => handleView(item)}>
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => navigate(`/questions/${item._id}`)}
                          >
                            Questions
                          </Dropdown.Item>
                          <Dropdown.Item
                            className="text-danger"
                            onClick={() => openDeleteConfirm(item)}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {service?.length > 0 ? (
        <div className="card-footer clearfix">
          <div className="d-flex justify-content-between align-items-center">
            <div className="dataTables_info" style={{ color: "#87C55F" }}>
              Showing {currentPage * itemsPerPage + 1} to{" "}
              {totalItems > (currentPage + 1) * itemsPerPage
                ? (currentPage + 1) * itemsPerPage
                : totalItems}{" "}
              of {totalItems} entries
            </div>
            <div className="d-flex align-items-center" style={{ gap: "10px" }}>
              <Pagination
                pageCount={totalPages}
                pageValue={currentPage}
                setPage={setCurrentPage}
              />
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      <Modal show={showModal} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#87C55F" }}>
            {selectedService ? "Edit Sub-Category" : "Add New Sub-Category"}
          </Modal.Title>
        </Modal.Header>

        <Formik
          initialValues={selectedService || initialFormValues}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={async (values, { setSubmitting }) => {
            try {
              if (selectedService) {
                const payload = {
                  categoryId: id,
                  name: values.name,
                  subCategoryId: values._id,
                };

                await updateSub(payload);
                toast.success("Updated successfully");
              } else {
                // ➕ Add
                await createSub(values);
                toast.success("Added successfully");
              }
              handleClose();
              getservices();
            } catch (error) {
              toast.error("Something went wrong");
              console.error(error);
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ isSubmitting, setFieldValue, value }) => (
            <FormikForm>
              <Modal.Body>
                {/* Title */}
                <Form.Group className="mb-3">
                  <Form.Label>Title</Form.Label>
                  <Field
                    name="name"
                    placeholder="ex. Thorax"
                    className="form-control"
                    style={{ borderColor: "#87C55F" }}
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="text-danger"
                  />
                </Form.Group>
              </Modal.Body>

              <Modal.Footer>
                <Button
                  type="submit"
                  disabled={isSubmitting}
                  style={{ backgroundColor: "#87C55F", border: "none" }}
                >
                  {selectedService ? "Update" : "Add"}
                </Button>
              </Modal.Footer>
            </FormikForm>
          )}
        </Formik>
      </Modal>
      <Modal show={confirmModal} onHide={() => setConfirmModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#dc3545" }}>Confirm Delete</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Are you sure you want to delete sub-category{" "}
          <strong>{confirmData?.name}</strong>?
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setConfirmModal(false)}>
            Cancel
          </Button>

          <Button
            onClick={confirmDelete}
            style={{
              backgroundColor: "#dc3545",
              border: "none",
            }}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SubSubjects;
